import { ITenantListStyles } from './TenantList.type';

export const tenantListStyles = (): ITenantListStyles => ({
  root: {
    ['p']: {
      lineHeight: '20px'
    }
  },
  introText: {
    marginTop: `18px`,
    marginBottom: 0
  }
});
